import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Accueil from './pages/Accueil';
import Footer from "./components/Footer/Footer";
import Club from "./pages/Club";
import EquipePremiere from "./pages/EquipePremiere";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "leaflet/dist/leaflet.css";
import SectionsPage from "./pages/SectionsPage";
import TeamPage from "./pages/TeamPage";
import ContactPage from "./pages/ContactPage";
import ActualitesPage from "./pages/ActualitesPage";
import MediaPage from "./pages/MediaPage";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";


function App() {
    const teams = [/* Mock data or fetched API data */];
    return (
        <Router>
            <Header />
            <ScrollToTop /> {/* Ajout de ScrollToTop */}
            <Routes>
                <Route path="/" element={<Accueil />} />
                <Route path="/club" element={<Club />} />
                <Route path="/equipe-premiere" element={<EquipePremiere />} />
                <Route path="/sections" element={<SectionsPage teams={teams} />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/actualites" element={<ActualitesPage />} />
                {/*<Route path="/boutique" element={<Boutique />} />*/}
                <Route path="/medias" element={<MediaPage />} />
                <Route path="/team/:teamId" element={<TeamPage />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
